import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Box, BoxProps } from '../grid';
export const trimTextNode = ({
  lineHeight
}: {
  lineHeight: number;
}) => {
  const descenderHeightScale = 0.13;
  const capHeightScale = 0.77;
  const typeOffset = (lineHeight - 1) / 2 + descenderHeightScale;
  const heightCorrection = lineHeight - capHeightScale;
  const preventCollapse = 1;
  return {
    paddingTop: `${preventCollapse}px`,
    /* baseline on bottom of container */
    transform: `translateY(${typeOffset}em)`,
    /* crop the top of the text node */
    '&:before': {
      content: '""',
      marginTop: `calc(${-heightCorrection}em - ${preventCollapse}px)`,
      display: 'block',
      height: 0
    }
  };
};
export function CroppedText(props) {
  const $ = _c(7);
  const t0 = Number(props.lineHeight) || 1.6;
  let t1;
  if ($[0] !== t0) {
    t1 = trimTextNode({
      lineHeight: t0
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      fontFamily: "inherit",
      fontWeight: "inherit",
      lineHeight: "body",
      fontSize: 2,
      ...t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== t2) {
    t3 = <Box __css={t2} {...props} />;
    $[4] = props;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export function Text(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fontFamily: "inherit",
      fontWeight: "inherit",
      lineHeight: "body",
      fontSize: 2,
      wordBreak: "break-word"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Box __css={t0} {...props} />;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function Heading(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fontSize: 4,
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading",
      color: "inherit"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Box as="h2" tx="text" variant="heading" {...props} __css={t0} />;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function Link(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fontFamily: "inherit",
      fontWeight: "heading",
      fontSize: "inherit",
      lineHeight: "body",
      display: "inline",
      textAlign: "inherit"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Box as="a" tx="text" variant="link" __css={t0} {...props} />;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export const Anchor = Link;